import React, { lazy } from 'react';
import { Switch, Route, useRouteMatch } from 'react-router-dom';

const ListingsReports = lazy(() => import('../../container/listings-reports'));
const View = lazy(() => import('../../container/listings-reports/View'));

function PagesRoute() {
  const { path } = useRouteMatch();
  return (
    <Switch>
      <Route exact path={`${path}/listings-reports`} component={ListingsReports} />
      <Route exact path={`${path}/listings-reports/view/:id`} component={View} />
    </Switch>
  );
}

export default PagesRoute;
